import React from 'react';
import { SURFACE } from './chartColors';

export type ChartType = 'doughnut' | 'bar' | 'horizontalBar' | 'bubble' | 'ranked';

interface ChartTypeSwitcherProps {
  options: ChartType[];
  active: ChartType;
  onChange: (type: ChartType) => void;
}

const ICONS: Record<ChartType, { path: string; label: string }> = {
  doughnut: {
    label: 'Doughnut',
    path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z',
  },
  bar: {
    label: 'Bar',
    path: 'M4 20h3V10H4v10zm5 0h3V4H9v16zm5 0h3v-7h-3v7z',
  },
  horizontalBar: {
    label: 'Horizontal Bar',
    path: 'M2 17h12v3H2v-3zm0-5h16v3H2v-3zm0-5h20v3H2V7z',
  },
  bubble: {
    label: 'Bubble',
    path: 'M7 10c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  },
  ranked: {
    label: 'Ranked List',
    path: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
  },
};

const ChartTypeSwitcher: React.FC<ChartTypeSwitcherProps> = ({ options, active, onChange }) => {
  return (
    <div className="flex gap-0.5 rounded-lg p-0.5" style={{ background: SURFACE.borderLight }}>
      {options.map((type) => {
        const icon = ICONS[type];
        const isActive = type === active;
        return (
          <button
            key={type}
            onClick={() => onChange(type)}
            title={icon.label}
            className="p-1.5 rounded-md transition-all duration-150"
            style={{
              background: isActive ? SURFACE.card : 'transparent',
              boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
              color: isActive ? SURFACE.text : SURFACE.textMuted,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d={icon.path} />
            </svg>
          </button>
        );
      })}
    </div>
  );
};

export default ChartTypeSwitcher;
